module.exports = __webpack_public_path__ + "img/ISTQB-International_original.40fb7e6e.png";